/* eslint-disable*/
var checkCfa2Subscription = function checkCfa2Subscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  //console.log(selectedLevel);
  //console.log(exam_data);
  //console.log(cfaUnlimitedPackage);
  //console.log(cfaUnlimitedActiveExam);
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (exam_data[i].levels[j].isActive) {
              flag = true;
              break;
            }
          }
        } else {
          flag = true; //for old user
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

var checkCfa2NotesSubscription = function checkCfa2NotesSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'expensive' &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'simple' &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              exam_data[i].levels[j].package_id === 21
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        } else {
          flag = true; //for old user
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

/*
------------------------
  Check for videos
-----------------------
*/
var checkCfa2VideosSubscription = function checkCfa2VideosSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'expensive' &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'simple' &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              exam_data[i].levels[j].package_id === 21
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};

/*
-----------------------
  Check for PDF's
----------------------
*/
var checkCfa2PDFSubscription = function checkCfa2PDFSubscription(
  selectedLevel,
  exam_data,
  cfaUnlimitedPackage,
  cfaUnlimitedActiveExam,
  type
) {
  var flag = false;
  if (
    cfaUnlimitedPackage === true ||
    (cfaUnlimitedPackage === 'true' && 'cfa' === cfaUnlimitedActiveExam)
  ) {
    if ('cfa' === cfaUnlimitedActiveExam) {
      return (flag = true);
    }
  } else {
    for (var i = 0; i < exam_data.length; i++) {
      if (exam_data[i].exam_name === selectedLevel) {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'expensive' &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === 'simple' &&
              exam_data[i].levels[j].isActive
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === 'question') {
                flag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === 'notes'
              ) {
                flag = true;
              }
            } else if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              exam_data[i].levels[j].package_id === 21
            ) {
              // console.log("work");

              flag = true;
              break;
            }
          }
        } else {
          flag = true;
        }
        break;
      } else {
        if (exam_data[i].levels.length) {
          for (var j = 0; j < exam_data[i].levels.length; j++) {
            if (
              exam_data[i].levels[j].package_val === 'unlimited' &&
              (exam_data[i].levels[j].package_id === 16 ||
                exam_data[i].levels[j].package_id === 18 ||
                exam_data[i].levels[j].package_id === 19 ||
                exam_data[i].levels[j].package_id === 39 ||
                exam_data[i].levels[j].package_id === 41 ||
                exam_data[i].levels[j].package_id === 50 ||
                exam_data[i].levels[j].package_id === 20)
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
    return flag;
  }
};
exports.checkCfa2Subscription = checkCfa2Subscription;
exports.checkCfa2NotesSubscription = checkCfa2NotesSubscription;
exports.checkCfa2VideosSubscription = checkCfa2VideosSubscription;
exports.checkCfa2PDFSubscription = checkCfa2PDFSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/Cfa2Subscription.js